import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  let resizeTimer;
  const refreshScrollTriggers = () => {
    clearTimeout( resizeTimer );
    resizeTimer = setTimeout( () => {
      requestAnimationFrame( () => ScrollTrigger.refresh( true ) );
    }, 250 );
  };

  const COMPONENT = {
    init: function() {
      const updateTopOffset = () => {
        let topOffset = $( 'header' ).height() || 0;
        if ( $( 'body.logged-in' ).length > 0 ) {
          topOffset += 32;
        }
        return topOffset;
      };

      window.addEventListener( 'announcementBannerClosed', refreshScrollTriggers );

      const root = this instanceof HTMLElement ? this : document.querySelector( '[data-component="scrolling-cards"]' );
      if ( !root ) return;

      const cardWrapper = root.querySelector( '.scrolling-cards__card-wrapper' );
      const mm = gsap.matchMedia();

      mm.add( '(max-width: 1023px)', () => {
        if ( cardWrapper ) {
          cardWrapper.classList.add( 'js-fade-group' );
        }

        return () => {
          if ( cardWrapper ) {
            cardWrapper.classList.remove( 'js-fade-group' );
          }
        };
      }, root );

      mm.add( '(min-width: 1024px)', () => {
        const pinElement = root.querySelector( '.scrolling-cards__pin' );
        const stageContainer = root.querySelector( '.scrolling-cards__stage-container' );
        const cardStages = root.querySelectorAll( '.scrolling-cards__card-stage' );

        if ( !pinElement || !cardStages.length || !stageContainer ) {
          return;
        }

        const getDistanceToBottom = () => {
          const stageTopRelativeToPin = stageContainer.offsetTop;
          return window.innerHeight - stageTopRelativeToPin;
        };

        gsap.set( cardStages, {
          y: () => 180,
          opacity: 0,
        } );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: pinElement,
            start: () => `top top+=${updateTopOffset()}px`,
            end: () => `+=${window.innerHeight * 0.75}`,
            pin: true,
            scrub: true,
            // markers: true,
            anticipatePin: 1,
            invalidateOnRefresh: true,
          },
        } );

        cardStages.forEach( ( card, index ) => {
          tl.to( card, {
            y: 0,
            opacity: 1,
            ease: 'power1.inOut',
          }, index * 0.1 );
        } );

        const handleRefreshInit = () => {
          updateTopOffset();
        };

        ScrollTrigger.addEventListener( 'refreshInit', handleRefreshInit );

        return () => {
          ScrollTrigger.removeEventListener( 'refreshInit', handleRefreshInit );
          gsap.set( cardStages, {clearProps: 'all'} );
        };
      }, root );
    },
    finalize: function() {},
  };
  app.registerComponent( 'scrolling-cards', COMPONENT );
} )( app );
